<div class="d-flex flex-column align-items-center justify-content-center text-center"
    style="min-height: 70vh; padding: 40px 20px;">
    <p class="mb-20">
        <img style="width: 280px" src="assets/images/my_list_empty.png" alt="Page not found" />
    </p>
    <h1 class="text-regular-bold fs-20">404 Error</h1>
    <h6 class="text-regular-bold mt-10">
        Oops! The page you are looking for<br />doesn't seem to exist
    </h6>
    <p class="txt-regular mt-10">
        Don't worry, we'll help you get<br />back on track
    </p>
    <a href="/" class="btn cc_p_btn mt-20">Back to home</a>
</div>
